module.exports = __webpack_public_path__ + "img/null_msgList.6b91d512.png";